<template>
  <div>
    <div class="headers" :class="router.currentRoute.value.name == 'home'&&scrollYs<10?'headers1':'headers2'">
      <div class="flex flex-col-center flex-row-between headers_blocks bodys">
        <img  @click="pageChange('/')" class="headers_lefts_icons" src="@/assets/logos.png" />
        <div v-if="!ispc" class="flex flex-col-center">
          <el-icon @click="pageChange('/searchs')" size="30"><Search /></el-icon>
          <el-icon @click="showlices=true,sliceIns=null" size="30"><Expand /></el-icon>
        </div>
        <div v-if="ispc" class=" flex flex-col-center">
          <div class="headers_items hoverse">
            <div @click="pageChange('/')" :class="{headers_items_names_checks:router.currentRoute.value.meta.keys=='/'&&!router.currentRoute.value.query.types}" class="headers_items_names">首页</div>
          </div>
          <div class="headers_items hoverse" v-for="(items1,inds1) in routes" :key="inds1">
            <div @click="pageChange1(items1)" :class="{headers_items_names_checks:items1.keys==router.currentRoute.value.meta.keys}" class="headers_items_names spacing">{{ items1.name }}</div>
            <div class="headers_items_blocks" v-if="items1.chirchens">
              <div class="headers_items_blocks1">
                <div  v-for="(items2,indes2) in items1.chirchens" :key="indes2">
                  <div  class="headers_items_blocks_names spacing" @click="pageChangebtns(items1.paths,items2)" 
                    :class="{
                      headers_items_blocks_check:
                        (items2.id && items2.id == router.currentRoute.value.query.ids&&items1.name == router.currentRoute.value.meta.title) ||
                        (items2.paths && items2.name == router.currentRoute.value.name),
                    }"
                  >{{ items2.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div @click="pageChange('/?types=en')"  :class="{headers_items_names_checks1:router.currentRoute.value.meta.keys=='/'&&router.currentRoute.value.query.types=='en'}" class="spacing headers_ens cur_po">EN</div>
          <div class="headers_lines"></div>
          <el-icon class="cur_po searchsicon" @click="issearchs=!issearchs"  size="14"><Search /></el-icon>
        </div>
      </div>
    </div>
    <div v-if="!ispc" class="headers_blocks"></div>

    <div class="slices" v-if="showlices">
      <div class="headers_blocks"></div>
      <div class="slices_items">
        <div @click="pageChange('/')" class="slices_items_names spacing">首页</div>
      </div>
      <div class="slices_items" v-for="(items1,inds1) in routes" :key="inds1">
        <div @click="slicesBtns1(items1,inds1)"  :class="{slices_items_checks:items1.keys==router.currentRoute.value.meta.keys}" class="slices_items_names spacing">{{ items1.name }}</div>
        <div class="slices_items_blocks" v-if="items1.chirchens&&sliceIns==inds1||items1.chirchens&&items1.keys==router.currentRoute.value.meta.keys">
          <div @click="pageChangebtns(items1.paths,items2)" 
          :class="{
              slices_items_checks:
                (items2.id && items2.id == router.currentRoute.value.query.ids&&items1.name == router.currentRoute.value.meta.title) ||
                (items2.paths && items2.name == router.currentRoute.value.name),
            }" class="slices_items_blocks_names spacing" v-for="(items2,indes2) in items1.chirchens" :key="indes2">{{ items2.name }}</div>
        </div>
      </div>
      <div class="slices_items">
        <div @click="pageChange('/?types=en')" class="slices_items_names spacing">EN</div>
      </div>
    </div>



    <div v-if="issearchs" class="searchs">
      <div class="headers_blocks"></div>
      <div class="searchs_mains flex flex-col-center flex-row-center">
        <div class="searchs_mains_centers flex flex-col-center">
          <el-icon  size="20"><Search /></el-icon>
          <input v-model="searchNames" class="searchs_mains_inputs spacing" type="text" placeholder="请输入项目名称" >
          <div @click="tosearchs" class="searchs_mains_btns cur_po spacing">搜索</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, watch, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码
import { useStore } from "vuex";
const store = useStore();

const ispc = computed(() => store.state.ispc);
const routes = computed(() => store.state.routes);
const baseUrls = computed(() => store.state.baseUrls);
const issearchs = ref(false)
const searchNames = ref("")
const showlices = ref(false)
const sliceIns = ref(null)
const scrollYs = ref(window.scrollY)

const pageChange1=(items)=>{
  if(!items.chirchens){
    pageChange(items.paths)
  }else{
      pageChangebtns(items.paths,items.chirchens[0])
  }
}
const slicesBtns1=(items,ins)=>{
  sliceIns.value=null
  if(!items.chirchens){
    pageChange(items.paths)
  }else{
    sliceIns.value=ins
  }
}
const pageChangebtns=(paths,items)=>{
  if(items.paths){
    pageChange(paths+"/"+items.paths)
  }else{
    pageChange(paths+"?ids="+items.id)
  }
}
const tosearchs=()=>{
  issearchs.value=false
  store.commit("setsearchNames", searchNames.value);
  pageChange('/searchs')
}


window.addEventListener("scroll",()=>{
  scrollYs.value=window.scrollY
})



const pageChange = (urls) => {
  issearchs.value=false
  showlices.value=false
  sliceIns.value=null
  window.scrollTo(0, 0);
  router.push(urls);
};
</script>

<style>
.slices{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background: #EFF0F0;
}


.headers {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 300;
}


@media screen and (max-width: 768px) {
  .headers_blocks{
    height: 110rem;
    padding: 0 20rem;
  }
  .headers_lefts_icons{
    height: 44rem;
  }
  .slices_items{
    padding: 0 30rem;
  }
  .slices_items_names{
    line-height: 110rem;
    font-size: 32rem;
    color: #000;
    border-bottom: 1rem solid rgba(0, 0, 0, 0.3);
  }
  .slices_items_blocks{
    padding: 20rem 0;
  }
  .slices_items_blocks_names{
    font-size: 28rem;
    line-height: 60rem;
  }
}
@media screen and (min-width: 768px) {


  .headers_blocks{
    height: 100px;
  }
  .headers_items{
    position: relative;
    margin: 0 14px;
  }
  .headers_items_names{
    font-size: 16px;
    color: #333;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    cursor: pointer;
    border-radius: 21px;
    position: relative;
    z-index: 20;
  }
  .headers_items_blocks{
    display: none;
    cursor: pointer;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%);
    padding: 50px 0 0;
  }
  .headers_items_blocks1{
    padding: 10px 15px ;
    background: #fff;
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.11);
  }
  .headers_items_blocks_names{
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 16px;
    color: #333;
    text-align: center;
    border-bottom:  2px solid #fff;
  }
  .headers_ens{
    font-size: 14px;
    color: #333;
  }
  .headers_lines{
    width: 1px;
    height: 15px;
    background: #333;
    margin: 0 8px;
  }
  .searchsicon{
    color: #333;
  }

  
  .searchs{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #fff;
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.11);
  }
  .searchs_mains{
    padding: 120px 0;
  }
  .searchs_mains_centers{
    width: 60%;
    border: 2px solid #085688;
    border-radius: 45px;
    padding: 0 0 0 20px;
  }
  .searchs_mains_inputs{
    flex:1;
    font-size: 18px;
    padding: 0 10px;
  }
.searchs_mains_btns{
    width: 100px;
    height: 55px;
    background: #085688;
    border-radius: 40px;
    font-size: 18px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
@media screen and (min-width: 768px) and (max-width: 1200px) {
}
@media screen and (min-width: 1200px) and (max-width: 1700px) {
}
@media screen and (min-width: 1700px) {
}
  .slices_items_checks{
    color: #085688 !important;
  }

  .headers2 {
    background: #fff;
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.11);
  }
  .headers1 .headers_items_names,
  .headers1 .searchsicon,
  .headers1 .headers_ens{
    color: #fff;
  }
  .headers1 .headers_items_names_checks,
  .headers1 .headers_lines{
    background: #fff;
    color: #085688;
  }
  .headers1 .headers_items_names_checks1{
    color: #085688;
  }

  .headers_items_names_checks{
    background: #085688;
    color: #FFFFFF;
  }
  .headers_items_names_checks1{
    color: #085688;
  }

.headers:hover{
  background: #fff;
}
.headers:hover .headers_items_names,
.headers:hover .searchsicon,
.headers:hover .headers_ens{
  color: #333333;
}
.headers:hover .headers_items_names_checks,
.headers:hover .headers_lines{
  background: #085688;
  color: #fff;
}
.headers:hover .headers_items_names_checks1{
  color: #085688;
}

.hoverse:hover .headers_items_names{
  background: #085688;
  color: #FFFFFF;
}
.hoverse:hover .headers_items_blocks{
  display: block;
}
.headers_items_blocks_check,
.headers_items_blocks_names:hover{
  color: #085688;
  border-color:  #085688;
}
</style>
